import SortableTable from '../../components/Table/SortableTable';
import { SquareCheckbox } from '../../components/Inputs/SquareCheckbox/SquareCheckbox';
import sharedUser from '../../assets/img/icons/common/shared_user.png';
import singleUser from '../../assets/img/icons/common/single_user.png';
import UserStatus from './UserStatus/UserStatus';
import Button from '../../components/UIButton/UIButton';
import { useAuth } from "react-oidc-context";
import { HierarchyUserStatus } from '../../constants/HierarchyUserStatus';

const UserManagementTable = ({ userData, isLoading, editClickHandler, setSelectedAccounts, selectedAccounts }) => {
    const loggedInUserEmail = useAuth()?.user?.profile?.email;
    const loggedInAccountId = userData?.find(u => u.email === loggedInUserEmail)?.accountId;
    const userDataWithoutLoggedInUser = userData?.filter(u => u.accountId !== loggedInAccountId);
    const headerClicked = (event) => {
        const isChecked = event.target.checked;
        if (isChecked) {
            const allAccounts = userDataWithoutLoggedInUser.map(x => x.accountId); //minus the logged in user
            setSelectedAccounts(allAccounts);
        }
        else {
            setSelectedAccounts([]);
        }
    }

    const handleCheckboxChange = (event, value) => {
        const isChecked = event.target.checked;
        if (isChecked) {
            setSelectedAccounts([...selectedAccounts, value]);
        } else {
            setSelectedAccounts(selectedAccounts.filter((item) => item !== value));
        }
    };

    const isAllUsersSelected = () => selectedAccounts.length === userDataWithoutLoggedInUser.map(x => x.accountId).length


    const columns = [
        {
            property: 'accountId',
            header: <div className="w-fit"><SquareCheckbox size="small" value={isAllUsersSelected()} valueChangeHandler={headerClicked} /></div>,
            custom: (value) => <div className="w-fit"><SquareCheckbox size="small" disabled={value === loggedInAccountId} value={selectedAccounts.some(x => x === value)} valueChangeHandler={(event) => handleCheckboxChange(event, value)} /></div>,
        },
        {
            property: 'name',
            header: 'NAME',
            sortable: true,
            custom: (value, row) => {
                if (row.userType === 2) {
                    return <div className={`d-flex align-items-center ${row.userStatus === 1 ? 'text-danger' : ""}`}><img src={sharedUser} alt="Shared User" className="mr-2" />{value}</div>
                }
                else {
                    return <div className={`d-flex align-items-center ${row.userStatus === 1 ? 'text-danger' : ""}`}><img src={singleUser} alt="Single User" className="mr-2" />{value}</div>
                }
            }
        },
        {
            property: 'email',
            header: 'EMAIL',
            sortable: true,
            custom: (value, row) => {
                if (row.userType === 2) {
                    return <div className="text-info">Shared User</div>
                }
                else {
                    return value;
                }
            }
        },
        {
            property: 'roleName',
            header: 'PERMISSION ROLE',
            sortable: true,
        },
        {
            property: 'locationCount',
            header: 'ASSIGNED LOCATIONS',
            sortable: true,
            custom: (value) => {
                if (value && value > 0) {
                    return `${value} Locations`;
                }
                else {
                    return 'N/A';
                }
            }
        },
        {
            property: 'userStatus',
            header: 'STATUS',
            sortable: true,
            initialSort: "asc",
            custom: (value, row) => {
                return <UserStatus status={value} accountId={row?.accountId} />
            }
        },
        {
            header: 'ACTIONS',
            custom: (value, row) => {
                return <Button variant="primary" size="small" onClick={() => editClickHandler(row?.accountId)}>Edit</Button>
            }
        },
    ]

    return (
        <SortableTable
            data={userData}
            columns={columns}
            isLoading={isLoading}
            loaderText="Loading users..."
            rowStyle={(user) => {
                return user.userStatus === HierarchyUserStatus.Pending ? 'bg-light-red' : ''
            }}
        />
    )
}

export default UserManagementTable;